import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { getConditionsFilterConfig } from '../filters/condition';
import { getSizeFilterConfig } from '../filters/size';
import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { BuilderSections } from '../../util/builder';
import { getGenderFilterConfig } from '../filters/gender';

const cafeducyclisteUsSizes = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'One Size'];

export const cafeducyclisteUsShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig(),
    getSizeFilterConfig({
      sizes: cafeducyclisteUsSizes,
    }),
    getBrandDirectFilterConfig(),
    getGenderFilterConfig(),
  ],
  builderConfig: {
    sections: {
      [BuilderSections.AboutPageHeroContent]: 'b65f41ad41294475a0cba67712a39cac',
      [BuilderSections.AboutPageInfoTabContent]: '54f4b08c56ad4c7f98df5c7755ba5d35',
      [BuilderSections.FooterContent]: '92549b15f66846c69bc4f6da98fbf700',
      [BuilderSections.LandingPageContent]: 'b780695b628b440688abe8cfb0dd1d1d',
      [BuilderSections.TopbarContent]: 'cb07a4baf8684dd18e7ef1e4589a9390',
    },
  },
};
